const $ = jQuery.noConflict();

export default function isMobile() {
    const tabletWidth = 960;

    return $(window).width() < tabletWidth;
}
